<template>
  <section class="phero">
    <div class="wrap">
      <span class="eyebrow"><span class="dot"></span>Find a Student</span>
      <h1 v-if="authUser" id="find-students">Find my student</h1>
    </div>
  </section>
  <div class="onr-body__find-instructors__container-view app-page app-body">
    <div class="onr-body__find-instructors__panel--filter">
      <div class="filter-container">
        <div class="filter__title">

          <span class="input__label">Subjects</span>
          <span class="accordion-chevron__down" :class="{ 'accordion-chevron__up' : toggleContent}"
                @click="toggleFilter('subject')">
						<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
							<path d="M19.1416 9.92896L12.7776 16.2929C12.3871 16.6834 11.7539 16.6834 11.3634 16.2929L4.99946 9.92895"
                    stroke="#000000" stroke-linecap="round"/>
						</svg>
					</span>
        </div>
        <div class="filter-checkbox" :class="filterClasses('subject')">
          <Checkbox
              class="subject-checkbox filter"
              v-for="(subject, index) in subjects"
              :key="`subject-${subject.key}-${index}`"
              v-model="subject.checked"
              :name="subject.label"
              :value="subject.value"
              @checked="onCheckboxChecked(subject, 'subject')"
              @unchecked="onCheckboxUnchecked(subject, 'subject')"
          ></Checkbox>
        </div>
      </div>
      <div class="filter-container">
        <div class="filter__title">
          <span class="input__label">Available Days</span>
          <span class="accordion-chevron__down" :class="{ 'accordion-chevron__up' : toggleContent}"
                @click="toggleFilter('day')">
						<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
							<path d="M19.1416 9.92896L12.7776 16.2929C12.3871 16.6834 11.7539 16.6834 11.3634 16.2929L4.99946 9.92895"
                    stroke="#000000" stroke-linecap="round"/>
						</svg>
					</span>
        </div>
        <div class="filter-checkbox" :class="filterClasses('day')">
          <Checkbox
              class="subject-checkbox filter"
              v-for="(day, index) in days"
              :key="`day-${day.key}-${index}`"
              v-model="day.checked"
              :name="day.label"
              :value="day.value"
              @checked="onCheckboxChecked(day, 'day')"
              @unchecked="onCheckboxUnchecked(day, 'day')"
          ></Checkbox>
        </div>
      </div>
      <div class="filter-container">
        <div class="filter__title">
          <span class="input__label">Available Time</span>
          <span class="accordion-chevron__down" :class="{ 'accordion-chevron__up' : toggleContent}"
                @click="toggleFilter('time')">
						<svg width="24px" height="24px" viewBox="0 0 24 24" fill="none">
							<path d="M19.1416 9.92896L12.7776 16.2929C12.3871 16.6834 11.7539 16.6834 11.3634 16.2929L4.99946 9.92895"
                    stroke="#000000" stroke-linecap="round"/>
						</svg>
					</span>
        </div>
        <div class="filter-checkbox" :class="filterClasses('time')">
          <Checkbox
              class="subject-checkbox filter"
              v-for="(time, index) in timeRange"
              :key="`time-${time.key}-${index}`"
              v-model="time.checked"
              :name="time.label"
              :value="time.value"
              @checked="onCheckboxChecked(time, 'time')"
              @unchecked="onCheckboxUnchecked(time, 'time')"
          ></Checkbox>
        </div>
      </div>
    </div>
    <div class="onr-body__find-instructors">
      <div class="onr-body__find-instructors-container">
        <div class="onr-body__find-instructors__panel--results">
          <div class="onr-body__find-instructors__panel--results-container">
            <div v-if="!authUser" class="onr-none-found">
              <h2>You must <a class="login-link" @click="openLogin()">login</a> to find a match.</h2>
            </div>
            <template v-for="(instructor, index) in filteredInstructors" :key="index">
              <div
                  class="onr-body__find-instructors__panel--card"
              >
                <div class="onr-body__find-instructors__panel--image">
                  <!-- <img class="panel-box__img" :src="profileImage"/> -->
                  <img
                      class="panel-box__img"
                      :src="getProfileSrc(instructor)"
                      @error="onInstructorImgError(instructor, $event)"
                  />
                </div>
                <div class="onr-body__find-instructors__panel--box">
                  <div class="onr-instructor__container">
                    <h2 class="onr-instructor__name">{{ instructor.firstName + " " + instructor.lastName }}</h2>
                    <h3 class="onr-instructor__subject">{{ subjectsByTeacher(instructor) }}</h3>
                    <div class="onr-instructor__info-container">
 <span v-if="formatGender(instructor.gender)" class="onr-instructor__gender">
  <svg
      class="info-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
  >
    <circle cx="12" cy="7" r="4"></circle>
    <path d="M5.5 21a6.5 6.5 0 0 1 13 0"></path>
  </svg>
  {{ formatGender(instructor.gender) }}
</span>
                      <span class="onr-instructor__country">
<img class="info-icon" src="../../assets/location.svg"/>
                        {{ getNameByCode(instructor.residence) }}
                      </span>
                      <span class="onr-instructor__country">
<img class="info-icon" src="../../assets/location.svg"/>
                        {{ getNameByRefCode(instructor.code) }}
                      </span>
                      <span class="onr-instructor__occupation">
												<img class="info-icon" src="../../assets/business.svg"/>
												{{ instructor.occupation }}</span>
                      <span class="onr-instructor__academicfields">
												<img class="info-icon" src="../../assets/academic.svg"/>
												{{ instructor.academicFields }}</span>
                      <span class="onr-instructor__interests">
												<img class="info-icon" src="../../assets/star.svg"/>
												{{ instructor.interests }}
											</span>
                      <span class="onr-instructor__availability">
												<img class="info-icon" src="../../assets/calendar.svg"/>
												{{ formattedAvailabilities(instructor) }}
											</span>
                    </div>
                  </div>

                  <div class="panel-box__schedule">
                    <router-link
                        class="onr-instructor__book"
                        v-if="instructor && instructor.uid"
                        :to="{ name: 'Student', params: { id: instructor.uid } }"
                        @click="onTeacherSelect(instructor.uid)"
                    >
                      Select
                    </router-link>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoginOverlay :showModal="showLoginModal" @close="close"></LoginOverlay>
</template>

<script>
import {findIndex, find, filter, map, union} from 'lodash';
import Checkbox from '../../components/checkbox.vue';
import LoginOverlay from '../../components/overlays/loginOverlay.vue';
import {auth} from '@/firebase.config';
import {ref, watchEffect} from "vue";
import {students} from "@/api/students";
import {getProfileImage} from "@/api/image";

import countries from '@/data/countries.json';
import {DateTime} from "luxon";

function getBrowserTimezone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
}

function getTeacherTimezone() {
  return localStorage.getItem("tz") || getBrowserTimezone() || "America/New_York";
}

const WEEKDAY = {Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7};

function parseAvailabilities(availableTimes) {
  // availableTimes가 JSON string이면 파싱
  if (Array.isArray(availableTimes)) return availableTimes;
  if (typeof availableTimes === "string") {
    try {
      const v = JSON.parse(availableTimes);
      if (Array.isArray(v)) return v;
    } catch (e) {
      // 혹시 "Mon 10:00, Tue 11:00" 같은 형태면 split도 지원
      console.log(e);
      return availableTimes.split(",").map(s => s.trim()).filter(Boolean);
    }
  }
  return [];
}

function nextOccurrenceInZone(weekdayNumber, hour, minute, zone) {
  // zone 기준 "오늘"에서 시작해 다음 해당 요일을 찾음
  let dt = DateTime.now().setZone(zone).startOf("day");
  // 오늘이 해당 요일이면 "오늘"로 잡히는데, 보통은 괜찮음(원하면 +7일로 넘길 수도)
  while (dt.weekday !== weekdayNumber) dt = dt.plus({days: 1});
  return dt.set({hour, minute, second: 0, millisecond: 0});
}

export default {
  name: 'FindInstructors',
  components: {
    LoginOverlay,
    Checkbox,
  },
  setup() {
    const instructors = ref([]);
    const filteredInstructors = ref([]);

    watchEffect(() => {
      students().then((resp) => {
        instructors.value = resp;
        filteredInstructors.value = resp;
      });
    });

    return {instructors, filteredInstructors};
  },
  data() {
    return {
      defaultProfileImg: new URL('../../assets/profile.jpeg', import.meta.url).href,
      showLoginModal: false,
      profileImage: '',
      days: [
        {
          label: 'Monday',
          value: 'Mon',
          checked: false,
        },
        {
          label: 'Tuesday',
          value: 'Tue',
          checked: false,
        },
        {
          label: 'Wednesday',
          value: 'Wed',
          checked: false,
        },
        {
          label: 'Thursday',
          value: 'Thu',
          checked: false,
        },
        {
          label: 'Friday',
          value: 'Fri',
          checked: false,
        },
        {
          label: 'Saturday',
          value: 'Sat',
          checked: false,
        },
        {
          label: 'Sunday',
          value: 'Sun',
          checked: false,
        },
      ],
      timeRange: [
        {
          label: '6:00',
          value: '6:00',
          checked: false,
        },
        {
          label: '7:00',
          value: '7:00',
          checked: false,
        },
        {
          label: '8:00',
          value: '8:00',
          checked: false,
        },
        {
          label: '9:00',
          value: '9:00',
          checked: false,
        },
        {
          label: '10:00',
          value: '10:00',
          checked: false,
        },
        {
          label: '11:00',
          value: '11:00',
          checked: false,
        },
        {
          label: '12:00',
          value: '12:00',
          checked: false,
        },
        {
          label: '13:00',
          value: '13:00',
          checked: false,
        },
        {
          label: '14:00',
          value: '14:00',
          checked: false,
        },
        {
          label: '15:00',
          value: '15:00',
          checked: false,
        },
        {
          label: '16:00',
          value: '16:00',
          checked: false,
        },
        {
          label: '17:00',
          value: '17:00',
          checked: false,
        },
        {
          label: '18:00',
          value: '18:00',
          checked: false,
        },
        {
          label: '19:00',
          value: '19:00',
          checked: false,
        },
        {
          label: '20:00',
          value: '20:00',
          checked: false,
        },
        {
          label: '21:00',
          value: '21:00',
          checked: false,
        },
      ],
      timeSlots: [
        {
          label: 'AM',
          checked: true
        },
        {
          label: 'PM',
          checked: true
        }
      ],
      subjects: [
        {
          label: 'English (SBS)',
          value: 'sbs',
          checked: false,
        },
        {
          label: 'LBL(Coding)',
          value: 'lbl_coding',
          checked: false,
        },
        {
          label: 'LBL(MS Office)',
          value: 'lbl_office',
          checked: false,
        },
        {
          label: 'Korean (한벗)',
          value: 'han',
          checked: false,
        }
      ],
      level: [
        'Beginner',
        'Intermediate',
        'Advanced'
      ],
      filterStatus: [
        {
          label: 'Subject',
          value: 'subject',
          open: true,
        },
        {
          label: 'Available Days',
          value: 'day',
          open: true,
        },
        {
          label: 'Available Time',
          value: 'time',
          open: true,
        },
      ],
    };
  },

  mounted() {

    window.scrollTo({top: 0, behavior: 'smooth'});
    // TODO Temp
    getProfileImage(auth.currentUser.uid).then((response) => {
      if (response !== '') {
        this.profileImage = response;
      } else {//temp
        this.profileImage = 'https://firebasestorage.googleapis.com/v0/b/mystic-tempo-383023.appspot.com/o/public%2Fprofile_4945750.png?alt=media';

      }
    }).catch((error) => {
      console.error(error);
    });
  },
  computed: {
    noFiltersSelected() {
      const s = this.subjects.some(x => x.checked);
      const d = this.days.some(x => x.checked);
      const t = this.timeRange.some(x => x.checked);
      return !(s || d || t);
    },
    authUser() {
      return auth.currentUser;
    },
    authenticated() {
      return localStorage.getItem('authenticated');
    },
  },
  methods: {
    formatGender(g) {
      if (g == null) return null;
      const s = String(g).trim().toLowerCase();

      // 너 DB 값 케이스들 대충 커버
      if (["m", "male", "man", "1"].includes(s)) return "Male";
      if (["f", "female", "woman", "2"].includes(s)) return "Female";
      if (["other", "o", "nonbinary", "non-binary", "nb", "3"].includes(s)) return "Other";
      if (["na", "n/a", "unknown", ""].includes(s)) return null;

      // 이미 사람이 읽을 형태면 그대로(예: "Male")
      return String(g);
    },
    getProfileSrc(instructor) {
      return instructor.profileImageUrl || this.defaultProfileImg;
    },
    onInstructorImgError(instructor, e) {
      // 화면 깨짐 방지: 즉시 fallback으로
      if (e.target.dataset.fallbackApplied) return;
      e.target.dataset.fallbackApplied = "1";
      e.target.src = this.defaultProfileImg;
    },
    formattedAvailabilities(instructor) {
      // ✅ 선생(뷰어) 기준 TZ
      const teacherTz = getTeacherTimezone();

      // ✅ 학생(원본) TZ
      const studentTz = instructor.timezone || "UTC";

      const slots = parseAvailabilities(instructor.availableTimes);

      const converted = slots.map((slot) => {
        const [dayAbbr, time] = slot.split(" ");
        const weekday = WEEKDAY[dayAbbr];
        if (!weekday || !time) return slot;

        const [hh, mm] = time.split(":").map(Number);

        // 학생 TZ 기준으로 "다음 해당 요일 hh:mm" 생성
        const src = nextOccurrenceInZone(
            weekday,
            hh,
            Number.isFinite(mm) ? mm : 0,
            studentTz
        );

        // 선생 TZ로 변환
        const dst = src.setZone(teacherTz);

        // ✅ 선생 시간대로 표시
        return `${dst.toFormat("ccc")} ${dst.toFormat("H")}:00`;
      });

      return converted.join(", ");
    },
    getNameByRefCode(code) {
      let country = '';
      if (code.toUpperCase().startsWith("BAGH")) {
        country = "Iraq";
      } else if (code.toUpperCase().startsWith("ERBI")) {
        country = "Iraq";
      } else if (code.toUpperCase().startsWith("BETH")) {
        country = "Bethlehem";
      } else if (code.toUpperCase().startsWith("ESKI")) {
        country = "Eskisehir";
      } else if (code.toUpperCase().startsWith("ISTA")) {
        country = "Istanbul";
      } else if (code.toUpperCase().startsWith("ANTI")) {
        country = "Antioch";
      } else if (code.toUpperCase().startsWith("JORD")) {
        country = "Jordan";
      } else if (code.toUpperCase().startsWith("GTC")) {
        country = "GTC";
      } else if (code.toUpperCase().startsWith("LEBA")) {
        country = "Lebanon";
      } else if (code.toUpperCase().startsWith("IRAQ")) {
        country = "Iraq";
      } else if (code.toUpperCase().startsWith("BRAZ")) {
        country = "Brazil";
      } else if (code.toUpperCase().startsWith("EGYP")) {
        country = "Egypt";
      } else if (code.toUpperCase().startsWith("DOMI")) {
        country = "Dominican Republic";
      } else if (code.toUpperCase().startsWith("MORO")) {
        country = "Morocco";
      } else {
        country = "";
      }
      return country ? country : null;
    },
    getNameByCode(countryCode) {
      const country = countries.find(country => country.code === countryCode);
      return country ? country.name : null;
    }
    ,
    uniqueInterests(instructor) {
      return union(instructor.interests);
    }
    ,
    filterClasses(type) {
      const currentType = find(this.filterStatus, (item) => item.value === type);
      return currentType.open ? '' : 'filter--close';
    }
    ,
    toggleFilter(type) {
      const currentType = find(this.filterStatus, (item) => item.value === type);
      currentType.open = currentType.open ? false : true;
      const index = findIndex(this.filterStatus, {value: type});
      this.filterStatus.splice(index, 1, {label: currentType.label, value: type, open: currentType.open});
    }
    ,

    subjectsByTeacher(instructor) {
      let subject = '';
      subject = (instructor.sbs ? 'English ' : '') + (instructor.lbl_coding ? 'Coding ' : '') + (instructor.lbl_office ? 'Office ' : '') + (instructor.han ? 'Korean' : '');
      return subject;
    }
    ,
    filterSubjects() {
      const selectedSubjects = this.subjects.filter(s => s.checked).map(s => s.value);
      const selectedDays = this.days.filter(d => d.checked).map(d => d.value);
      const selectedTimes = this.timeRange.filter(t => t.checked).map(t => t.value);

      // ✅ 아무 필터도 선택 안 했으면 전체 반환
      const noFilters =
          selectedSubjects.length === 0 &&
          selectedDays.length === 0 &&
          selectedTimes.length === 0;

      if (noFilters) return this.instructors;

      return this.instructors.filter((student) => {
        // 1) subject 필터 (선택된 게 있을 때만 적용)
        if (selectedSubjects.length > 0) {
          const subjectMatch =
              (selectedSubjects.includes("sbs") && student.sbs === 1) ||
              (selectedSubjects.includes("lbl_coding") && student.lbl_coding === 1) ||
              (selectedSubjects.includes("lbl_office") && student.lbl_office === 1) ||
              (selectedSubjects.includes("han") && student.han === 1);

          if (!subjectMatch) return false;
        }

        // availability는 변환 비용이 있으니, day/time 필터 필요할 때만 계산
        const needAvailability = selectedDays.length > 0 || selectedTimes.length > 0;
        const availability = needAvailability ? this.formattedAvailabilities(student) : "";

        // 2) day 필터
        if (selectedDays.length > 0) {
          const dayMatch = selectedDays.some(d => availability.includes(d));
          if (!dayMatch) return false;
        }

        // 3) time 필터
        if (selectedTimes.length > 0) {
          const timeMatch = selectedTimes.some(t => availability.includes(t));
          if (!timeMatch) return false;
        }

        return true;
      });
    },
    filterDays() {
      const filteredResults = [];
      filter(this.instructors, (instructor) => {
        const availabilities = instructor.availableTimes;
        map(this.days, (day) => {
          const regex = new RegExp(day.value, 'i');
          const isAvailableDay = regex.test(availabilities);

          day.value === 'mon' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
          day.value === 'tue' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
          day.value === 'wed' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
          day.value === 'thu' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
          day.value === 'fri' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
          day.value === 'sat' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
          day.value === 'sun' && day.checked && isAvailableDay ? filteredResults.push(instructor) : '';
        });
      });
      return union(filteredResults);
    }
    ,
    onCheckboxChecked(val, type) {
      if (type === 'subject') {
        const currentType = find(this.subjects, (item) => item.value === val.value);
        const index = findIndex(this.subjects, {value: val.value});
        this.subjects.splice(index, 1, {label: currentType.label, value: currentType.value, checked: true});
        this.filteredInstructors = this.filterSubjects();
      }

      if (type === 'day') {
        const currentType = find(this.days, (item) => item.value === val.value);
        const index = findIndex(this.days, {value: val.value});
        this.days.splice(index, 1, {label: currentType.label, value: currentType.value, checked: true});
        this.filteredInstructors = this.filterSubjects();
      }

      if (type === 'time') {
        const currentType = find(this.timeRange, (item) => item.value === val.value);
        const index = findIndex(this.timeRange, {value: val.value});
        this.timeRange.splice(index, 1, {label: currentType.label, value: currentType.value, checked: true});
        this.filteredInstructors = this.filterSubjects();
      }
    }
    ,
    onCheckboxUnchecked(val, type) {
      if (type === 'subject') {
        const currentType = find(this.subjects, (item) => item.value === val.value);
        const index = findIndex(this.subjects, {value: val.value});
        this.subjects.splice(index, 1, {label: currentType.label, value: currentType.value, checked: false});
        this.filteredInstructors = this.filterSubjects();
      }

      if (type === 'day') {
        const currentType = find(this.days, (item) => item.value === val.value);
        const index = findIndex(this.days, {value: val.value});
        this.days.splice(index, 1, {label: currentType.label, value: currentType.value, checked: false});
        this.filteredInstructors = this.filterSubjects();
      }

      if (type === 'time') {
        const currentType = find(this.timeRange, (item) => item.value === val.value);
        const index = findIndex(this.timeRange, {value: val.value});
        this.timeRange.splice(index, 1, {label: currentType.label, value: currentType.value, checked: false});
        this.filteredInstructors = this.filterSubjects();
      }
    }
    ,
    openLogin() {
      this.showLoginModal = true;
    }
    ,
    onTeacherSelect(teacherId) {
      if (!teacherId) {
        console.warn("[FindInstructors] Missing teacherId (uid).", teacherId);
        return;
      }

      this.$router.push({
        name: "Student",
        params: {id: teacherId},
      });
    },
    close() {
      this.showLoginModal = false;
    }
    ,
  },
  watch: {
    authUser(val) {
      if (val) {
        console.log('...user is now loggede in!');
        window.location.reload();
      }
    }
    ,
  }
  ,
}
</script>

<style lang="scss">
@use '../../utils/_tokens.scss' as *;

.subject-checkbox {
  &.filter {
    text-align: left;
    padding-left: 0;
    margin-top: 0.5rem;
    margin-left: 1rem;

    @media only screen and (max-width: 550px) {
      margin-left: 0;
    }

    .checkbox-checkmark {
      left: unset;
      right: 0;
    }
  }
}

.onr-none-found {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 70vh;
  width: 100%;
  margin-top: 5rem;

  .login-link {
    cursor: pointer;
    text-decoration: underline;
  }
}

.onr-instructor {
  &__info-container {
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    height: 150px;
    overflow-y: auto; // 세로만 스크롤
    overflow-x: hidden;
    max-width: 400px;
    padding: 0 1rem;

    @media only screen and (max-width: 550px) {
      margin: 0;
    }
  }

  &__container {
    display: flex;
    flex-direction: column;
    margin-bottom: 30px;
  }

  &__name {
    color: $blue-1;
    font-size: 30px;
    font-weight: 900;
    margin: 10px 0 0;
    text-transform: uppercase;
  }

  &__subject {
    color: $blue-2;
    font-size: 1em;
    font-weight: 400;
    margin: 0 0 15px;
  }

  &__occupation, &__interests, &__academicfields, &__availability, &__country, &__residence, &__gender {
    font-size: 13px;
    text-align: left;

    .info-icon {
      width: 15px;
      vertical-align: sub;
    }
  }

  &__book {
    background-color: $blue-1;
    color: white;
    padding: 5px 40px;
    text-decoration: none;
    text-transform: uppercase;

    &:visited {
      color: white;
      text-decoration: none;
    }

    &:hover {
      color: white;
      text-decoration: none;
    }

    &:active {
      color: white;
      text-decoration: none;
    }
  }
}


.panel {
  &-box {
    &__top {
      display: flex;

      .panel-box {
        &__subject {
          margin-left: auto;

          &-label {
            color: $grey-1;
            text-transform: uppercase;
            font-size: 12px;
            font-weight: 800;
            vertical-align: sub;
          }
        }

        &__level {
          display: flex;

          &-label {
            color: $grey-1;
            font-size: 13px;
            font-weight: 500;
            margin: 7px 0 0 8px;
            text-transform: capitalize;
          }
        }
      }
    }

    &__schedule {
      margin: 5px;

      &-link {
        color: black;
        cursor: pointer;
        font-weight: 400;
        text-decoration: none;

        &:link {
          color: black;
          text-decoration: none;
        }

        &:visited {
          color: black;
          text-decoration: none;
        }

        &:hover {
          color: black;
          text-decoration: none;
        }

        &:active {
          color: black;
          text-decoration: none;
        }

        &--arrow {
          vertical-align: bottom;
        }
      }

    }

    &__img {
      width: 100%;
    }

    &__course {
      padding: 14px 10px 0px 10px;
      min-height: 82.8px;
      text-align: left;

      &-title {
        font-size: 17px;
        font-weight: 800;
        line-height: 1.2;
        margin: 0;
      }
    }

    &__name {
      padding: 0;

      &-label {
        color: $grey-1;
        font-size: 13px;
        font-weight: 400;
      }
    }
  }

  &-checkbox {
    display: block;
    text-align: left;
    margin: 0 0 5px 30px;
  }

  &-filter {
    &__button {
      background-color: $green-1;
      border: none;
      color: white;
      cursor: pointer;
      padding: 8px 20px;

      &-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 42px 0 10px;
      }
    }

    &__reset {
      &-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 6px 0 26px;
      }

      &-link {
        color: $grey-1;
        cursor: pointer;
        font-size: 13px;
        font-weight: 600;
        text-transform: uppercase;
      }
    }
  }
}

.onr-body {
  overflow-x: hidden;

  &__find-instructors {
    margin: 0 1rem 1rem;
    text-align: center;

    &--heading {
      font-size: 3em;
      padding: 1rem;
    }

    &__container-view {
      display: flex;
      flex-direction: row;

      @media only screen and (max-width: 630px) {
        flex-direction: column;
      }
    }

    &__panel {
      &--box {
        width: 100%;
        margin-bottom: 2rem;
      }

      &--image {
        height: 250px;
        overflow: hidden;

        .panel-box__img {
          object-fit: cover;
          width: 100%;
          border-radius: 18px;
        }
      }

      &--results {
        width: 100%;

        &-container {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          width: 100%;

          @media only screen and (max-width: 1250px) {
            .onr-body__find-instructors__panel--card {
              width: 46%;
            }
          }

          @media only screen and (max-width: 950px) {
            .onr-body__find-instructors__panel--card {
              width: 95%;
            }
          }

          @media only screen and (max-width: 590px) {
            .onr-body__find-instructors__panel--card {
            }
          }

        }
      }

      // &--card {
      // 	background-color: $neutral-1;
      // 	border: 1px solid $neutral-2;
      // 	border-radius: 18px;
      // 	box-shadow: 0 1px 3px rgba(83, 91, 96, 0.23);
      // 	margin: 0 20px 20px 0;
      // 	width: 26%;
      // }

      &--card {
        display: flex;
        flex-direction: column;
        width: auto;
        align-items: center;
        padding: 0;
        border: 1px solid $grey-4;
        border-radius: 18px;
        margin-right: 1rem;
        margin-bottom: 1rem;
        max-width: 400px;
      }

      &--filter {
        height: fit-content;
        margin: 0 2rem 2rem 3rem;
        white-space: nowrap;
        text-align: left;

        background-color: $beige-1;
        border-radius: 5px;
        padding: 2rem;

        display: flex;
        flex-direction: column;

        @media only screen and (max-width: 550px) {
          margin: 1rem;
          padding: 1rem 0 1rem 1rem;
        }

        .filter-container {
          font-size: 1em;

          .filter-checkbox {
            .filter {
              font-size: 0.8em;

              @media only screen and (max-width: 550px) {
                margin-right: 1.5rem;
              }
            }

            &.filter--close {
              display: none;
            }
          }

          .filter__title {
            display: flex;

            .accordion-chevron__down {
              margin-left: auto;
              order: 2;

              @media only screen and (max-width: 550px) {
                margin-right: 1.2rem;
              }
            }
          }
        }

        .filter-checkbox {
          margin: 1rem 0 2rem;
        }

        .dropdown--subjects {
          width: 19.1em;
          height: 2.5em;
        }

        &-box {
          width: 200px;

          &.onr-subjects {
            text-align: left;
          }

          &.onr-available-days, .onr-available-times {
            text-align: left;
          }
        }
      }
    }

    &-container {
      display: flex;
      flex-direction: column;
    }

    &--heading {
      font-size: 3em;

      @media only screen and (max-width: 500px) {
        font-size: 2em;
      }
    }
  }
}

.onr-checkbox {
  &__span {
    color: $black-1;
    font-size: 13px;
    font-weight: 500;
  }

  &__container {
    input {
      vertical-align: middle;
    }
  }
}

.onr-heading {
  &__subjects, &__availability, &__available-time {
    color: $grey-2;
    font-size: 15px;
    font-weight: 700;
    margin: 5px 0 10px 33px;
    text-align: left;
  }

  &__availability, &__available-time {
    margin-top: 20px;
  }
}
</style>
